import { SAVE_CANDIDATES } from './actions';

export const initialState = {};

// eslint-disable-next-line default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_CANDIDATES:
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
